<template>
    <div class="grinding-select custom-select">
        <select>
            <option
                v-for="grinding in grindingItems"
                :key="grinding.ID"
                :value="grinding.ID"
                :selected="grinding.ID === value"
            >{{ grinding.VALUE }}</option>
        </select>
    </div>
</template>

<script>
import { ICONS_PATH } from '../../../constants';

function getGrindingIconPath(grindingObj) {
    return `${ICONS_PATH}${grindingObj.XML_ID}.svg`;
}

export default {
    name: 'grinding-select',

    props: {
        grindingItems: {
            type: Array,
            required: true,
        },

        value: {
            required: false,
        },

        theme: {
            type: String,
            default: 'default',
        },

        selectWidth: {
            default: '100%',
        },
    },

    methods: {
        bindEvents() {
            $(this.$el).on('change', ({ target }) => {
                this.$emit('input', target.value);
            });
        },

        initCustomSelect() {
            $(this.$el.querySelector('select')).select2({
                minimumResultsForSearch: -1,
                templateSelection: this.templateResult,
                templateResult: this.templateResult,
                width: this.selectWidth,
                theme: this.theme,
                dropdownAutoWidth: true,
                dropdownParent: $(this.$el),
            });
        },

        templateResult(state) {
            const item = this.grindingItems.find((i) => +i.ID === +state.id);

            if (!item) {
                return null;
            }

            // const iconPath = getGrindingIconPath(item);

            return $(`
                <div class="grinding-select__item grinding-item grinding-item--select-cart">
                    <svg>
                        <use xlink:href="/sprite.svg#icon-grinding-${item.XML_ID}"></use>
                    </svg>
                    <span>${item.VALUE}</span>
                </div>
            `);
        },
    },

    computed: {
        currentGrinding() {
            const grinding = this.grindingItems.find(({ ID }) => ID === this.value);

            if (!grinding) {
                return null;
            }

            return {
                ...grinding,
                ICON_PATH: getGrindingIconPath(grinding),
            };
        },
    },

    mounted() {
        this.initCustomSelect();
        this.bindEvents();
    },
};
</script>
